import { LookupModelSearchEvent } from "@mcleod/components";
import { AutogenLayoutTractorContinuityReport } from "./autogen/AutogenLayoutTractorContinuityReport";

export class TractorContinuityReport extends AutogenLayoutTractorContinuityReport {
    override onLoad(): void | Promise<void> {
        this.textboxDateType.selectedItem = this.textboxDateType.items[0];
        this.textboxTractorStatus.selectedItem = this.textboxTractorStatus.items[0];
        this.textboxDriverType.selectedItem = this.textboxDriverType.items[0];
    }

    excludabletextboxFTextboxBeforeLookupModelSearch(event: LookupModelSearchEvent) {
        event.filter.is_trailer = "Y"
    }
}
